import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2725fbcc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "show-must-login"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "You have been logged out", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Please log back in to continue your work", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_button = _resolveComponent("app-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, _createVNode(_component_app_button, {
    loading: $data.loading,
    onClick: $options.handleLogin
  }, {
    default: _withCtx(() => [_createTextVNode("Login")]),
    _: 1
  }, 8, ["loading", "onClick"])]);
}